import type { TipsCollection } from '@flobi/asset-library/hints';

/**
 * The Tips page (/tips): Artwork's hints (artworkHints.tsx) as collections, by what people want
 * to do in the editor. Every id in ARTWORK_HINTS belongs to exactly one collection.
 */
export const TIP_COLLECTIONS: TipsCollection[] = [
  {
    id: 'shaping',
    name: 'Drawing and shaping',
    line: 'Pick tools by key and build the shapes you want.',
    ids: ['artwork.shape-builder', 'artwork.merge-by-colour', 'artwork.mask-instead', 'artwork.tool-keys', 'artwork.select-key'],
  },
  {
    id: 'copies',
    name: 'Making copies',
    line: 'Copy, repeat and vary layers, and keep every copy editable.',
    ids: ['artwork.duplicate-shortcut', 'artwork.alt-drag-copy', 'artwork.cloner', 'artwork.effectors'],
  },
  {
    id: 'arranging',
    name: 'Arranging',
    line: 'Order, group and line up layers, and move around the page.',
    ids: [
      'artwork.group-shortcut',
      'artwork.enter-group',
      'artwork.arrange-shortcuts',
      'artwork.distribute',
      'artwork.big-nudge',
      'artwork.select-same-fill',
      'artwork.zoom-keys',
    ],
  },
  {
    id: 'colour',
    name: 'Colour and assets',
    line: 'Pick colours, type and pictures that stay on brand.',
    ids: ['artwork.eyedropper', 'artwork.brand-colour', 'artwork.brand-type', 'artwork.my-stuff', 'artwork.assets-shortcut'],
  },
  {
    id: 'animating',
    name: 'Animating',
    line: 'Play your page and set when each layer moves.',
    ids: ['artwork.animate-space', 'artwork.animate-timing'],
  },
  {
    id: 'exporting',
    name: 'Exporting and sharing',
    line: 'Get your work out as files, for screen or print, and share it.',
    ids: ['artwork.export-shortcut', 'artwork.export-all', 'artwork.slices', 'artwork.export-video', 'artwork.cmyk-for-print', 'artwork.share-shortcut'],
  },
];

/**
 * The page's words where the card's speak to a moment ("You've been duplicating one by one"):
 * on the page the tip is read before the moment comes.
 */
export const TIPS_CONTENT: Record<string, { title?: string; body?: string }> = {
  'artwork.cloner': {
    body: 'The Cloner repeats your selection in a row, grid or circle, and every copy stays editable.',
  },
};

/**
 * The tip the page leads with once none is new (while some are, the first new one leads, so the first
 * collection opens with this too): the Shape Builder, Artwork's own way to make shapes.
 */
export const START_HERE = 'artwork.shape-builder';
